import React, { useState, useEffect } from 'react';

import { getCompaniesByFilterAsyncSelect } from '@core/utils/company/companyAsyncSelect.utils';
import { useLanguage } from 'FielderUtils/Contexts/LanguageContext';

import AsyncSelect from '~/AsyncSelect/AsyncSelect.component';

const getCompanies = getCompaniesByFilterAsyncSelect;

const AsyncSelectCompanies = ({ value, onSelect, ...selectProps }) => {
	const lan = useLanguage();
	const [selectValue, setSelectValue] = useState([]);

	useEffect(() => {
		if (value) {
			setSelectValue(value);
		}
	}, [value]);

	const handleSelect = (e, option) => {
		setSelectValue(e);

		// Filter the ids to only send to the parent component
		const newValue = e.map(({ value }) => value.id);
		onSelect(newValue, option);
	};

	return (
		<AsyncSelect
			multiple
			getOptions={getCompanies}
			onChange={handleSelect}
			value={selectValue}
			label={`${lan.select} ${lan.companies}`}
			{...selectProps}
		/>
	);
};

export default AsyncSelectCompanies;
